var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50974 0.128424C8.81415 -0.0428082 9.18585 -0.0428082 9.49026 0.128424L17.4903 4.62842C17.8051 4.80554 18 5.13873 18 5.5V10C18 10.5523 17.5523 11 17 11C16.4477 11 16 10.5523 16 10V7.20985L10 10.5848V19C10 19.3553 9.81151 19.6839 9.50485 19.8632C9.19818 20.0426 8.81938 20.0457 8.50974 19.8716L0.509739 15.3716C0.194862 15.1945 0 14.8613 0 14.5V5.5C0 5.13873 0.194862 4.80554 0.509739 4.62842L8.50974 0.128424ZM9 8.85265L14.9603 5.5L9 2.14735L3.03973 5.5L9 8.85265ZM2 7.20985V13.9152L8 17.2902V10.5848L2 7.20985ZM15.2929 13.7071C14.9024 13.3166 14.9024 12.6834 15.2929 12.2929C15.6834 11.9024 16.3166 11.9024 16.7071 12.2929L19.7071 15.2929C20.0976 15.6834 20.0976 16.3166 19.7071 16.7071L16.7071 19.7071C16.3166 20.0976 15.6834 20.0976 15.2929 19.7071C14.9024 19.3166 14.9024 18.6834 15.2929 18.2929L16.5858 17H12C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15H16.5858L15.2929 13.7071Z",
    fill: "#33CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBox);
export default __webpack_public_path__ + "static/media/circleBox.a128d7bbc5b68032ebf04447b5bd27ea.svg";
export { ForwardRef as ReactComponent };